import React, { Component } from 'react';

// import Project from './Project'
import Section from '../pageContent/Section'

import './Contents.css'

class Contents extends Component {

    render() {

        const { work } = this.props


        return (

            <div className="contents ptlg pblg md-ptsm md-pbsm xs-pt0">

                <div className="grid">

                    <div className="unit whole">

                        <div className="projects">

                            <div className="grid">

                                {work.map((item, index) => {
                                    const offset = index % 2 === 0 ? false : true

                                    // return <Project key={index} offset={offset} {...item} />
                                    return <Section key={index} offset={offset} {...item } />

                                })}

                            </div>

                        </div>

                    </div>

                </div>

            </div>
        );
    }
}

export default Contents;